module.exports = __webpack_public_path__ + "img/slide-2.096c674e.jpg";